import basicInsurancePolicy from '../../InsurancePolicy/basicInsurancePolicy';

const adminBasicInsurancePolicy = {
  executiveManagerId: '',
  insuranceBrokerId: '',
  ...basicInsurancePolicy
};

export default adminBasicInsurancePolicy;
